// extracted by mini-css-extract-plugin
export default {"CustomPropertySelectPanelButton":"CustomPropertySelectPanel-module__CustomPropertySelectPanelButton__U4ZZE5A"};